<template>
  <section class="container my-10 flex justify-center">
    <div
      class="toggle-wrapper relative overflow-hidden rounded-full bg-scheme-main-bis"
    >
      <BlokkliField
        name="field_paragraphs"
        :list="filterNullArray(paragraphs)"
        class="toggle-list relative inline-flex"
      />

      <Teleport to="body">
        <div v-if="isPartyMode" class="party-toggle-overlay">
          <div />
        </div>
      </Teleport>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { ParagraphToggleFragment } from '#graphql-operations'
import { filterNullArray } from '~/helpers'

defineProps<ParagraphToggleFragment>()

defineBlokkli({
  bundle: 'toggle',
  globalOptions: ['bkHiddenGlobally', 'publicationChannels'],
  propsFieldMapping: {
    paragraphs: { type: 'field', name: 'field_paragraphs' },
  },
})

const { isPartyMode } = usePartyToggle()
</script>

<style>
@reference '~/assets/css/tailwind.css';
/* Position the toggle background behind the active toggle item. */
@supports (position-anchor: inherit) {
  .toggle-wrapper:before {
    content: '';
    @apply pointer-events-none absolute top-0 left-0 h-full rounded-full bg-primary;
    @apply transition-all duration-300 ease-bounce;
    position-anchor: --toggle-anchor;
    left: anchor(left);
    width: anchor-size(width);
  }
}

.party-toggle-overlay {
  @apply pointer-events-none fixed top-0 left-0 h-full w-full overflow-hidden bg-transparent;
  z-index: -1;

  div {
    @apply relative top-0 left-0 h-full w-full;
    background: linear-gradient(
      120deg,
      rgb(163, 13, 101),
      rgb(230, 48, 142),
      rgb(253, 202, 0)
    );
  }

  &.fade-enter-active,
  &.fade-leave-active {
    @apply opacity-100;
    transition: 0.9s;
  }
  &.fade-enter,
  &.fade-leave-to {
    @apply opacity-0;
  }
}
</style>
